module.exports = __webpack_public_path__ + "static/media/postgres.bcedffc5.jpg";